// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"700e267c","277":"5223ce2d"}[chunkId] + ".chunk.js";
};